import React from 'react';

interface TrialCountdownIconProps {
  daysRemaining: number;
  totalDays?: number;
  size?: number;
}

const TrialCountdownIcon: React.FC<TrialCountdownIconProps> = ({
  daysRemaining,
  totalDays = 14,
  size = 24,
}) => {
  const strokeWidth = 2.5;
  const radius = (size - strokeWidth) / 2;
  const center = size / 2;
  const progress = Math.max(0, Math.min(1, daysRemaining / totalDays));

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background track (depleted portion) */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        stroke="rgba(255,255,255,0.3)"
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Foreground arc - white, shrinks as days run out */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        stroke="white"
        strokeWidth={strokeWidth}
        fill="none"
        pathLength={1}
        strokeDasharray={`${progress} 1`}
        strokeDashoffset={0}
        transform={`rotate(-90 ${center} ${center})`}
      />
      {/* Days number */}
      <text
        x={center}
        y={center}
        textAnchor="middle"
        dominantBaseline="central"
        fill="white"
        fontSize={size * 0.4}
        fontWeight="700"
        fontFamily="Montserrat, system-ui, sans-serif"
      >
        {daysRemaining}
      </text>
    </svg>
  );
};

export default TrialCountdownIcon;
